export const API_CONFIG = {
  BASE_URL:
    process.env.REACT_APP_API_BASE_URL ||
    "https://quadruply-expiatory-madelene.ngrok-free.dev/",
  TIMEOUT: 100000,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || "development",
};

/** Disparado en la misma pestaña al actualizar `localStorage` de empresa (Header / login). */
export const COMPANY_CHANGED_EVENT = "company-changed";

export function dispatchCompanyChanged(): void {
  window.dispatchEvent(new CustomEvent(COMPANY_CHANGED_EVENT));
}
